module.exports = __webpack_public_path__ + "static/media/dex-view-logo.0f8687cd.png";